module.exports = __webpack_public_path__ + "img/Saber-Kendo-Logo-Template.jpg";